import intl from "react-intl-universal";

//当前支持的工作流节点
export const WORK_TYPE_ID_LIST = [
  'tts.proofread.pronounce',
  'tts.proofread.voice',
  'tts.voice.emotionTag.proofread',
  'tts.prosodicAnnotate',
  'tts.proofread.dict',
  'tts.proofread.polyphonicWordV2',
  'tts.wordLabeling.proofread',]

export const QuestionTypeList = [
  { type: 1, name: intl.get("be0ecb2d-4d1f-22ca-91e6-59ee7d226516") },
  { type: 2, name: intl.get("93dc9fd5-4c98-2177-8224-e592b911dc03") }
];

export const ImageTypeList = ["image/png", "image/jpeg", "image/jpg", "image/gif"];
export const AudioTypeList = ["audio/aac", "audio/vnd.dlna.adts", "audio/mpeg", "audio/wav"];
export const VideoTypeList = ["video/3gpp", "video/mp4", "video/mpeg", "video/quicktime"];


export const CountSearchList = [
  // symbol:1:大于，2：小于,3:等于
  { label: intl.get("2bd6a1cc-0f40-2c39-8b98-761ea0c02340"), value: '{ "value": 0, "symbol": 1 }' },
  { label: intl.get("bf9aefca-06b7-26f8-a610-90fe4371d565"), value: '{ "value": 0, "symbol": 3 }' },
  { label: intl.get("35a7b62b-7571-2f64-bacb-a16b56c5809d"), value: '{ "value": 1, "symbol": 3 }' },
  { label: intl.get("189f0ee3-02f3-214f-bc68-d366d673d109"), value: '{ "value": 2, "symbol": 3 }' },
  { label: intl.get("e999869f-00b6-2576-8bfd-37fda7aada09"), value: '{ "value": 3, "symbol": 3 }' },
];

// 公开范围 ：
export const PublicScopeList = [
  { label: intl.get("b52d02c5-4b3a-2a13-975b-fca0ef5e7377"), value: '1' },
  { label: intl.get("6b0f68ed-35ef-2ce6-8bf1-a5afc243e263"), value: '2' },
  { label: intl.get("67b79c71-fa45-2b84-a6ab-1b9916b3fb82"), options: [] }
];

export const TagColorMap = [
  {
    'bg': '#EEEAFF',
    'text': '#0B1BFF',
  },
  {
    'bg': '#E2F1FF',
    'text': '#0078E8',
  },
  {
    'bg': '#FFF2E2',
    'text': '#8A4F08',
  },
  {
    'bg': '#FFE2EF',
    'text': '#C700E2',
  },
  {
    'bg': '#FFE8E9',
    'text': '#FF0B0F',
  },
  {
    'bg': '#E2FFE5',
    'text': '#00950F',
  },
  {
    'bg': '#FFF5E2',
    'text': '#E97800',
  },
  {
    'bg': '#E8DAFF',
    'text': '#8D0BFF',
  }
];

// 试卷类型 培训类型
export const examTypeList = [
  { id: 1, label: intl.get("general") },
  { id: 2, label: intl.get("TTSSpeechSynthesis") },
];

export const MaxValue = 2147483647;